import { render, staticRenderFns } from "./HtmlImporter.vue?vue&type=template&id=bcf05744"
import script from "./HtmlImporter.vue?vue&type=script&lang=js"
export * from "./HtmlImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports